export default function Data() {
  return (
    <div className="">
          <h3> WEB SCRAPER </h3>
          <h4 className="black"> This basic Web Scraper is made with Scrapy in Python and the data is saved as json files.
                I began scraping Legal data from government websites such as pulling articles from the Constitution full text online.
                In the future when parsing data for a larger AI project, I will focus on deploying and automation with Azure PostgreSQL and GitHub Actions.
                In addition, I will pivit to looking for websites to scrape that are better formatted and therefore better to parse through.
          </h4>
          <img className="video-big" src="https://i.postimg.cc/9Qb6SHSp/Screenshot-2026-01-24-at-5-31-02-PM.png" align="center" alt="constitution"></img>
          <p></p>
          <a href = "https://github.com/TREYCSE/Web_Scraper_csv" className="github">  Click here for repo </a>
          <p></p>
      </div>
    )
  }



/*

SQL medical database also in progress, researching best sites to scrape and clean - stay tuned on progress! 
          <h3> SQL database </h3>
          <a href = "https://github.com/TREYCSE/Data_SQL" className="title"> Database in progress </a>
          <h4> In progress... </h4>

*/


